/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';

import {LocalNetworkInfo} from '../../../components/session/local-network-info';
import template from './supporting-pages-page.component.html';

@Component({
  standalone: false,
  selector: 'adn-supporting-pages-page',
  template
})
export class SupportingPagesPageComponent {
  clearTheme(): void {
    LocalNetworkInfo.obtain().clearSuppInfo();
  }
}
